<template  >
  <div class="freightSpace"
       v-loading.fullscreen.lock="fullscreenLoading">

    <el-dialog title="创建区域"
               class="new_dialog"
               :visible.sync="newShow"
               width="40%">

      <el-form :model="formData"
               ref="formData"
               label-width="100px"
               class="demo-ruleForm">
        <el-form-item label="请输入区域名:"
                      label-width="150"
                      prop="area"
                      :rules="[
      { required: true, message: '区域不能为空哦.'},
    ]">
          <el-input v-model="formData.area">
          </el-input>
        </el-form-item>

        <el-form-item label="请输入货架数量:"
                      label-width="150"
                      prop="number"
                      :rules="[
      { required: true, message: '货架数量不能为空.'},
    ]">

          <el-input-number v-model="formData.number"
                           size='mini '
                           :min="1"
                           :max="20"></el-input-number>
        </el-form-item>

        <el-form-item label="请输入货架层数:"
                      label-width="150"
                      prop="tier"
                      :rules="[
      { required: true, message: '货架层数不能为空.'},
    ]">
          <el-input-number v-model="formData.tier"
                           size='mini '
                           :min="1"
                           :max="20"></el-input-number>
        </el-form-item>

        <el-form-item label="请输入每层格数:"
                      label-width="150"
                      prop="grid"
                      :rules="[
      { required: true, message: '货架数量不能为空.'},
    ]">
          <el-input-number v-model="formData.grid"
                           size='mini '
                           :min="1"
                           :max="20"
                           label="描述文字"></el-input-number>
        </el-form-item>

        <el-form-item label="请输入区域说明:"
                      label-width="150"
                      style="width:100%"
                      prop="info"
                      :rules="[
      { required: true, message: '区域说明不能为空哦'},
    ]">
          <el-input style="width:100%"
                    type="textarea"
                    :rows="2"
                    maxlength="30"
                    show-word-limit
                    v-model="formData.info">
          </el-input>
        </el-form-item>
      </el-form>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="newShow = false">取 消</el-button>
        <el-button type="primary"
                   @click="submitForm('formData')">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title='区域设置'
               z-index:100
               class="set_dialog"
               :visible.sync="isSetShow"
               width="40%">
      <div class="pageRange">
        <div class="pageRange_item"
             v-for="(item,index) in dataJson"
             :key="index">
          <el-input :disabled='!(disabledBtn===index)'
                    @blur='confirm_name(index)'
                    :maxlength="4"
                    :class="(disabledBtn===index)?'active_input':''"
                    v-model="dataJson[index].lable">
          </el-input>
          <el-dropdown placement='bottom'>
            <span class="el-dropdown-link">
              <i class="el-icon-setting"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <el-button size='mini'
                           class="btn_click"
                           style="width:100%"
                           @click="rename(index)"
                           type="primary">重命名</el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button size='mini'
                           class="btn_click"
                           style="width:100%"
                           @click="alter_area_info_show(index)"
                           type="primary">改简介</el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button size='mini'
                           class="btn_click"
                           style="width:100%"
                           @click="remove_area(index)"
                           type="danger">删 除</el-button>
              </el-dropdown-item>

            </el-dropdown-menu>
          </el-dropdown>

        </div>

      </div>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="isSetShow = false">取 消</el-button>
        <el-button type="primary"
                   @click="isSetShow=false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title='修改区域简介'
               class="set_dialog"
               :visible.sync="area_info"
               width="30%">
      <el-form :model="briefData"
               ref="dataJsonValidateForm"
               label-width="100px"
               class="demo-ruleForm">
        <el-form-item label="简介"
                      prop="info"
                      :rules="[
      { required: true, message: '区域不能为空'},
    ]">
          <el-input type="textarea"
                    :rows="2"
                    placeholder="请输入内容"
                    v-model="briefData.info">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="submitForm_2('dataJsonValidateForm')">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="创建货架"
               class="new_dialog"
               :visible.sync="add_show"
               width="40%">

      <el-form :model="formData"
               ref="formData"
               label-width="100px"
               class="demo-ruleForm">

        <el-form-item label="请输入货架层数:"
                      label-width="150"
                      prop="tier"
                      :rules="[
      { required: true, message: '货架层数不能为空.'},
    ]">
          <el-input-number v-model="formData.tier"
                           size='mini '
                           :min="1"
                           :max="20"></el-input-number>
        </el-form-item>

        <el-form-item label="请输入每层格数:"
                      label-width="150"
                      prop="grid"
                      :rules="[
      { required: true, message: '货架数量不能为空.'},
    ]">
          <el-input-number v-model="formData.grid"
                           size='mini '
                           :min="1"
                           :max="20"
                           label="描述文字"></el-input-number>
        </el-form-item>

      </el-form>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="add_show = false">取 消</el-button>
        <el-button type="primary"
                   @click="confirm_goods('formData')">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="打印"
               class="prin_dialog"
               :visible.sync="print_show"
               width="70%">
      <div class="printView">
        <el-tabs v-model="first"
                 type="card">
          <el-tab-pane label="打印区号"
                       name="first">
            <div class="printView_main">
              <el-form ref="area_form"
                       :model="print_selected"
                       label-width="80px">
                <el-form-item label-width="200"
                              label="请选择您要打印的区域:">
                  <br />
                  <div class="select_area">
                    <ul>
                      <li v-for="(item,index) in dataJson"
                          :key="index">
                        <el-radio v-model="print_selected.area"
                                  :label=index>
                          {{item.lable}}
                        </el-radio>
                      </li>
                    </ul>
                  </div>
                </el-form-item>
                <el-form-item label-width="200"
                              label=""
                              v-if="print_selected.area!==''">
                  <br>
                  <div class="print_select_btn">
                    <el-tooltip effect="dark"
                                content="只打印区号,不打印其中的货架/层格信息"
                                placement="top">
                      <el-button type="primary"
                                 @click="print_area_show('area')">打 印 区 号</el-button>
                    </el-tooltip>
                    <el-tooltip effect="dark"
                                content="打印其中所有的货架/层格,但是不打印区号"
                                placement="top">
                      <el-button type="primary"
                                 @click="print_area_show('all')">打 印 内 容</el-button>
                    </el-tooltip>
                  </div>

                </el-form-item>

              </el-form>
              <div class="select_content"></div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="打印货架"
                       name="second">
            <el-form ref="area_form"
                     :model="print_selected"
                     label-width="80px">
              <el-form-item label-width="200"
                            label="请选择您要打印的区域:">
                <br />
                <div class="select_area">
                  <ul>
                    <li v-for="(item,index) in dataJson"
                        :key="index">
                      <el-radio v-model="print_selected.area"
                                :label=index>
                        {{item.lable}}
                      </el-radio>
                    </li>
                  </ul>
                </div>
              </el-form-item>

              <el-form-item label-width="200"
                            v-if="print_selected.area!==''"
                            label="请选择您要打印的货架:">
                <br />
                <div class="select_area">
                  <ul>
                    <li v-for="(item,index) in dataJson[print_selected.area].children"
                        :key="index">
                      <el-radio v-model="print_selected.goods"
                                :label='index'>
                        {{item.lable}}
                      </el-radio>
                    </li>

                  </ul>
                </div>
              </el-form-item>

              <el-form-item label-width="200"
                            label=""
                            v-if="print_selected.goods!==''">
                <br>
                <div class="print_select_btn">
                  <el-tooltip effect="dark"
                              content="只打印货架号,不打印其中的层格信息"
                              placement="top">
                    <el-button type="primary"
                               @click="print_area_show('goods')">打 印 货 架 号</el-button>
                  </el-tooltip>
                  <el-tooltip effect="dark"
                              content="打印其中所有的层格"
                              placement="top">
                    <el-button type="primary"
                               @click="print_area_show('allGoods')">打 印 内 容</el-button>
                  </el-tooltip>
                </div>

              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="打印格号"
                       name="third">
            <el-form ref="area_form"
                     :model="print_selected"
                     label-width="80px">
              <el-form-item label-width="200"
                            label="请选择您要打印的区域:">
                <br />
                <div class="select_area">
                  <ul>
                    <li v-for="(item,index) in dataJson"
                        :key="index">
                      <el-radio v-model="print_selected.area"
                                :label=index>
                        {{item.lable}}
                      </el-radio>
                    </li>
                  </ul>
                </div>
              </el-form-item>

              <el-form-item label-width="200"
                            v-if="print_selected.area!==''"
                            label="请选择您要打印的货架:">
                <br />
                <div class="select_area">
                  <ul>
                    <li v-for="(item,index) in dataJson[print_selected.area].children"
                        :key="index">
                      <el-radio v-model="print_selected.goods"
                                :label='index'>
                        {{item.lable}}
                      </el-radio>
                    </li>

                  </ul>
                </div>
              </el-form-item>
              <el-form-item label-width="200"
                            v-if="print_selected.goods!==''"
                            label="请选择您要打印的格子:">
                <br />
                <div class="select_area">
                  <el-checkbox-group v-model="print_selected.grid"
                                     size="mini">

                    <ul class="grid_ul">
                      <li class="grid_li"
                          v-for="(item,index) in dataJson[print_selected.area].children[print_selected.goods].children"
                          :key="index+11">
                        <el-checkbox v-for="(item_2,index_2) in item.children"
                                     :key="index_2+22"
                                     :label="index+'-'+index_2"
                                     border>{{item.lable+item_2.lable}}</el-checkbox>
                      </li>

                    </ul>
                  </el-checkbox-group>
                </div>
              </el-form-item>
              <el-form-item label-width="200"
                            label=""
                            v-if="print_selected.grid!=''">
                <br>
                <div class="print_select_btn">
                  <el-tooltip effect="dark"
                              content="浏览选中的格子"
                              placement="top">
                    <el-button type="primary"
                               @click="print_area_show('selectedGrid')">浏 览 打 印</el-button>
                  </el-tooltip>
                </div>

              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>

    <transition name="el-fade-in-linear">
      <div class="print_main"
           v-if="printShow">
        <div class="print_main_view">
          <div class='printBotton'>
            <el-button class='printBotton_btn'
                       size="mini"
                       type="primary"
                       v-print="printObj">
              <i class="el-icon-printer"></i>
              打 印
            </el-button>
            <el-button class='printBotton_btn'
                       size="mini"
                       type="danger"
                       @click="printShow=false">
              取 消
            </el-button>
            <el-button @click.stop="is_area_number"
                       v-if="skip_type=='goods'"
                       style="color:#fff;border:0;transition: all .3s;"
                       :class="is_print_area?'is_true':'is_false'">
              <span>{{is_print_area?'打印区号':'不打印区号'}}</span>
            </el-button>

          </div>
          <!-- 打印区域号 -->
          <div class="print_area_ul"
               v-if="skip_type=='area'">
            <div class="printArea"
                 id="printJS-form"
                 ref='print'>
              <div class="printArea_top">
                {{dataJson[print_selected.area].lable}}
              </div>
              <div class="printArea_info">
                {{dataJson[print_selected.area].info}}
              </div>
            </div>
          </div>

          <!-- 打印区域号 -->
          <div class="print_area_ul"
               v-if="skip_type=='goods'">
            <div class="printArea"
                 id="printJS-form"
                 ref='print'>
              <div class="printArea_top"
                   v-if='is_print_area'>
                {{dataJson[print_selected.area].lable}}-{{dataJson[print_selected.area].children[print_selected.goods].value}}
              </div>
              <div class="printArea_top"
                   v-else>
                {{dataJson[print_selected.area].children[print_selected.goods].value}}
              </div>
              <div class="printArea_info">
                {{dataJson[print_selected.area].info}}
              </div>
            </div>
          </div>

          <!-- 打印所有数据 -->
          <div class="print_main_ul"
               v-if="skip_type=='all'"
               id="printJS-form"
               ref='print'>
            <span class="print_main_li"
                  v-for="(item,index) in dataJson[print_selected.area].children "
                  :key='index'>
              <span class="printGrid"
                    v-for="(item_2,index_2) in dataJson[print_selected.area].children[index].children "
                    :key='index_2+2'>
                <div class="printTier"
                     v-for="(item_3,index_3) in dataJson[print_selected.area].children[index].children[index_2].children"
                     :key="index_3+3">
                  <div class="print_main_li_area">
                    {{dataJson[print_selected.area].lable}}-{{item.value}}-{{item_2.value}}-{{item_3.value}}
                  </div>
                  <div class='print_main_code'>
                    <div class="print_code_left">
                      <span>{{dataJson[print_selected.area].lable}}区域 - {{item.lable}}</span>
                      <span>{{item_2.lable}}-{{item_3.lable}}</span>

                    </div>
                    <div class="print_code_right">
                      <vue-qr :text='dataJson[print_selected.area].lable+"-"+item.value+"-"+item_2.value+"-"+item_3.value'
                              :margin="0"
                              colorDark="#000"
                              colorLight="#fff"
                              :logoScale="0.3"
                              :size="70"></vue-qr>
                    </div>
                  </div>
                  <div class="barcode">
                    <svg class="content_item_code"
                         :id="(dataJson[print_selected.area].lable+'-'+item.value+'-'+item_2.value+'-'+item_3.value)">{{useBarcode(dataJson[print_selected.area].lable+'-'+item.value+'-'+item_2.value+'-'+item_3.value,'#barcode',dataJson[print_selected.area].lable+"-"+item.value+"-"+item_2.value+"-"+item_3.value)}}</svg>
                  </div>
                </div>
              </span>
            </span>
          </div>

          <!-- 打印指定货架数据 -->
          <div class="print_main_ul"
               v-if="skip_type=='allGoods'"
               id="printJS-form"
               ref='print'>
            <span class="print_main_li">
              <!-- v-for="(item,index) in dataJson[print_selected.area].children "
                  :key='index' -->
              <span class="printGrid"
                    v-for="(item_2,index_2) in dataJson[print_selected.area].children[print_selected.goods].children "
                    :key='index_2+2'>
                <div class="printTier"
                     v-for="(item_3,index_3) in dataJson[print_selected.area].children[print_selected.goods].children[index_2].children"
                     :key="index_3+3">
                  <div class="print_main_li_area">
                    {{dataJson[print_selected.area].lable}}-{{dataJson[print_selected.area].children[print_selected.goods].value}}-{{item_2.value}}-{{item_3.value}}
                  </div>
                  <div class='print_main_code'>
                    <div class="print_code_left">
                      <span>{{dataJson[print_selected.area].lable}}区域 - {{dataJson[print_selected.area].children[print_selected.goods].lable}}</span>
                      <span>{{item_2.lable}}-{{item_3.lable}}</span>

                    </div>
                    <div class="print_code_right">
                      <vue-qr :text='dataJson[print_selected.area].lable+"-"+dataJson[print_selected.area].children[print_selected.goods].value+"-"+item_2.value+"-"+item_3.value'
                              :margin="0"
                              colorDark="#000"
                              colorLight="#fff"
                              :logoScale="0.3"
                              :size="70"></vue-qr>
                    </div>
                  </div>
                  <div class="barcode">
                    <svg class="content_item_code"
                         :id="(dataJson[print_selected.area].lable+'-'+dataJson[print_selected.area].children[print_selected.goods].value+'-'+item_2.value+'-'+item_3.value)">{{useBarcode(dataJson[print_selected.area].lable+'-'+dataJson[print_selected.area].children[print_selected.goods].value+'-'+item_2.value+'-'+item_3.value,'#barcode',dataJson[print_selected.area].lable+"-"+dataJson[print_selected.area].children[print_selected.goods].value+"-"+item_2.value+"-"+item_3.value)}}</svg>
                  </div>
                </div>
              </span>
            </span>
          </div>

          <!-- 打印选中的格子 -->
          <div class="print_main_ul"
               v-if="skip_type=='selectedGrid'"
               id="printJS-form"
               ref='print'>
            <span class="print_main_li">
              <!-- v-for="(item,index) in dataJson[print_selected.area].children "
                  :key='index' -->
              <span class="printGrid">
                <div class="printTier"
                     v-for="(item_3,index_3) in this.selectedTier "
                     :key="index_3+3">
                  <div class="print_main_li_area">
                    {{dataJson[print_selected.area].lable}}-{{dataJson[print_selected.area].children[print_selected.goods].value}}-{{dataJson[print_selected.area].children[print_selected.goods].children[item_3.c].value}}-{{dataJson[print_selected.area].children[print_selected.goods].children[item_3.c].children[item_3.g].value}}
                  </div>
                  <div class='print_main_code'>
                    <div class="print_code_left">
                      <span>{{dataJson[print_selected.area].lable}}区域 - {{dataJson[print_selected.area].children[print_selected.goods].lable}}</span>
                      <span>{{dataJson[print_selected.area].children[print_selected.goods].children[item_3.c].lable}}-{{dataJson[print_selected.area].children[print_selected.goods].children[item_3.c].children[item_3.g].lable}}</span>

                    </div>
                    <div class="print_code_right">
                      <vue-qr :text='dataJson[print_selected.area].lable+"-"+dataJson[print_selected.area].children[print_selected.goods].value+"-"+dataJson[print_selected.area].children[print_selected.goods].children[item_3.c].value+"-"+dataJson[print_selected.area].children[print_selected.goods].children[item_3.c].children[item_3.g].value'
                              :margin="0"
                              colorDark="#000"
                              colorLight="#fff"
                              :logoScale="0.3"
                              :size="70"></vue-qr>
                    </div>
                  </div>
                  <div class="barcode">
                    <svg class="content_item_code"
                         :id="(dataJson[print_selected.area].lable+'-'+dataJson[print_selected.area].children[print_selected.goods].value+'-'+dataJson[print_selected.area].children[print_selected.goods].children[item_3.c].value+'-'+dataJson[print_selected.area].children[print_selected.goods].children[item_3.c].children[item_3.g].value)">{{useBarcode(dataJson[print_selected.area].lable+'-'+dataJson[print_selected.area].children[print_selected.goods].value+'-'+dataJson[print_selected.area].children[print_selected.goods].children[item_3.c].value+'-'+dataJson[print_selected.area].children[print_selected.goods].children[item_3.c].children[item_3.g].value,'#barcode',dataJson[print_selected.area].lable+"-"+dataJson[print_selected.area].children[print_selected.goods].value+"-"+dataJson[print_selected.area].children[print_selected.goods].children[item_3.c].value+"-"+dataJson[print_selected.area].children[print_selected.goods].children[item_3.c].children[item_3.g].value)}}</svg>
                  </div>
                </div>
              </span>
            </span>
          </div>
        </div>
      </div>
    </transition>

    <!----------------------------------------------------------->
    <div class="freightSpace_top">
      <div class="freightSpace_btn">
      </div>
    </div>
    <div class="freightSpace_main "
         :class="!dataJson[0]?'el-flex':''">
      <div class="abs_set">
        <el-tooltip class="item"
                    effect="dark"
                    content="添加区域"
                    placement="top">
          <el-button type="success"
                     icon="el-icon-plus"
                     @click="show_new_freight_space"
                     circle></el-button>
        </el-tooltip>
        <el-tooltip class="item"
                    effect="dark"
                    content="区域设置"
                    placement="top">
          <el-button type="primary"
                     icon="el-icon-setting"
                     @click="isSetShow=true"
                     circle></el-button>
        </el-tooltip>
        <el-tooltip class="item"
                    effect="dark"
                    content="打印"
                    placement="top">
          <el-button type="primary"
                     icon="el-icon-printer"
                     @click="print_show=true"
                     circle></el-button>
        </el-tooltip>
      </div>
      <!-- 没有数据显示 -->
      <div class="data_null"
           v-if="!dataJson[0]">
        <div class="data_null_image"></div>
        <div class="data_null_text">没有仓库信息,请先
          <el-link @click="show_new_freight_space"
                   type="primary">创建区域</el-link>
        </div>
      </div>
      <!-- 正常 -->
      <el-tabs type="border-card"
               @tab-add='show_new_freight_space'
               @tab-click='active_label'
               v-else>
        <el-tab-pane v-for="(item,index) in dataJson"
                     :key="index">
          <span slot="label"> {{item.lable}}
          </span>
          <div class="freightSpace_main_area"
               :class="!item.children?'el-flex ':''">
            <div class="brief">
              <el-alert title="区域说明"
                        type="warning"
                        :description='item.info'>
              </el-alert>
            </div>
            <!-- 非正常数据显示 -->
            <div class="dataJson_null"
                 v-if="!item.children">
              <div class="dataJson_null_img"> </div>
              <span class="dataJson_null_text">没有货架数据,请先
                <el-link @click="add_goods_shelf(item.children,index)"
                         type="primary">添加货架</el-link>
              </span>
            </div>
            <!--正常数据显示 -->
            <el-tabs style="width"
                     editable
                     @tab-remove='remove_goods_shelf($event,index)'
                     @tab-add='add_goods_shelf(item.children,index)'
                     v-if='item.children'
                     v-model="defuend_tabs">
              <el-tab-pane :label="item_2.lable"
                           :name="index_2+'tet'"
                           v-for="(item_2,index_2) in item.children"
                           :key="index_2">
                <div class="goods_shelf">
                  <!-- 添加层 -->
                  <div class="goods_shelf_item">
                    <el-tooltip effect="dark"
                                content="添加层"
                                placement="top">
                      <el-button plain
                                 class="add_grid"
                                 style="background-color:#409eff"
                                 @click="add_tier(item_2.children,index,index_2)"
                                 size='mini '>
                        <i class='el-icon-plus'></i>
                      </el-button>
                    </el-tooltip>

                  </div>
                  <!-- 添加层 end-->
                  <div class="goods_shelf_item"
                       v-for="(item_3,index_3) in item_2.children"
                       :key="index_3">
                    <el-button v-for="(item_4,index_4) in item_3.children"
                               :key="index_4"
                               plain
                               class="grid_data_class"
                               :class="(index_3+1) %2==0?'odd_btn':'' ">
                      {{item_3.lable}}{{item_4.lable}}
                      <i class="delete_grid el-icon-close "
                         @click="remove_grid(item_3,index_4)"></i>
                    </el-button>

                    <el-tooltip effect="dark"
                                content="添加格"
                                placement="top">
                      <el-button plain
                                 size='mini '
                                 @click="add_tier_grid(index,index_2,index_3)"
                                 :key='index_2+index_3+"addg"'
                                 class="add_grid">
                        <i class='el-icon-plus'></i>
                      </el-button>
                    </el-tooltip>
                  </div>

                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { createLogger } from 'vuex'
import common from '@/assets/js/common'
import { apiFreightSpace } from '@/request/api'
import VueQr from 'vue-qr'

export default {
  name: 'FreightSpace',
  components: {
    VueQr
  },
  data () {
    return {
      //-----选中的格----
      selectedTier: [],
      //-----是否打印区号----
      is_print_area: true,
      //-----判断进入的类型----
      skip_type: '',
      //-----显示浏览打印内容----
      printShow: false,
      //-----打印设置----
      printObj: {
        id: "printJS-form",
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
      },
      defuend_tabs: '0tet',
      first: 'first',
      //-----打印选择----
      print_selected: {
        area: '',
        goods: '',
        grid: []
      },
      // selectedPrint:'',
      //是否显示打印 --------
      print_show: false,
      // 简介-----------
      briefData: {
        info: ''
      },
      add_show: false,
      active_index: 0,
      area_info: false,
      temporary: '',
      temporary_item: '',
      temporary_index: '',

      fullscreenLoading: true,
      test: '',
      //是否禁用
      disabledBtn: '',
      // 设置是否显示
      isSetShow: false,
      //当前选中的tab
      activeLabel: 0,
      formData: {
        area: '',
        info: '',
        number: '',
        tier: '',
        grid: ''
      },
      newShow: false,
      activeID: this.$route.query.id,
      dataJson: []
    }
  },
  methods: {
    //---------是否打印区域号-------
    is_area_number () {
      this.is_print_area = !this.is_print_area
    },
    //---------打印所有内容-------
    print_area_show (type) {
      if (type == 'selectedGrid') {
        for (const key in this.print_selected.grid) {
          this.selectedTier.push({
            c: this.print_selected.grid[key].split("-")[0],
            g: this.print_selected.grid[key].split("-")[1]
          })

        }
      }
      this.printShow = true
      this.skip_type = type
    },
    //---------调用打印-------
    print (e) {
      this.$print(this.$refs.print)
    },
    //---------封装条形码-------
    useBarcode (item, id, text) {
      this.barcode('#' + item, text, 'bottom')
    },
    //---------转条形码-------
    barcode (id, code, position, w, h) {
      setTimeout(() => {
        console.log(code);
        var JsBarcode = require('jsbarcode')
        let barCode = code
        JsBarcode(id, barCode, {
          format: 'CODE128',//选择要使用的条形码类型
          text: barCode, //显示文本
          displayValue: true,//是否在条形码下方显示文字
          width: w ? w + 'px' : '2px', //条宽度
          height: h ? h + 'px' : '50px', //高度
          textPosition: position ? position : 'bottom',//设置文本的垂直位置
          // fontOptions: “bold italic”,//使文字加粗体或变斜体
          // background: “#eee”,//设置条形码的背景
          font: 'Play',//设置文本的字体
          margin: 5//设置条形码周围的空白边距

        })
      }, 1);
    },
    //--------添加层数-------------
    add_tier (item, index, index_2) {
      this.$confirm(`确定添加第${parseInt(item[0].value) + 1}层吗?`, '添加层数', {
        confirmButtonText: '添 加',
        cancelButtonText: '取 消',
        type: 'warning',
      }).then(() => {
        this.dataJson[index].children[index_2].children.unshift({
          lable: `${parseInt(item[0].value) + 1}层`,
          value: parseInt(item[0].value) + 1,
          children: [{
            lable: '1格',
            value: 1
          }]
        })
      }).catch(() => {

      });

    },
    //--------删除格子-------------
    remove_grid (item, index) {
      this.$confirm(`确定删除吗?该操作不可逆转!!!`, '删除格子', {
        confirmButtonText: '删 除',
        cancelButtonText: '取 消',
        type: 'warning',
      }).then(() => {
        item.children.splice(index, 1)
        this.freight_space_data(this.dataJson)
      }).catch(() => {

      });
    },
    //--------添加格子-------------
    add_tier_grid (q, h, c) {

      let tier = this.dataJson[q].children[h].children[c].children

      if (this.dataJson[q].children[h].children[c].children == undefined || !this.dataJson[q].children[h].children[c].children[0]) {
        this.$set(this.dataJson[q].children[h].children[c], 'children', [
          {
            lable: '1格',
            value: 1
          }
        ])
        return this.freight_space_data(this.dataJson)
      }
      let tierDate = this.dataJson[q].children[h].children[c].children[this.dataJson[q].children[h].children[c].children.length - 1]

      this.dataJson[q].children[h].children[c].children.push({
        lable: (parseInt(tierDate.value) + 1) + '格',
        value: (parseInt(tierDate.value) + 1)
      })
      // this.freight_space_data(this.dataJson)
    },
    //--------删除货架-------------
    remove_goods_shelf (e, index) {
      this.$confirm(`确定删除吗?该操作不可逆转!!!`, '删除货架', {
        confirmButtonText: '删 除',
        cancelButtonText: '取 消',
        type: 'warning',
      }).then(() => {
        let index_2 = parseInt(e.substring(0, 1))
        this.dataJson[index].children.splice(index_2, 1);
        this.freight_space_data(this.dataJson, () => {
          this.$router.go(0)
          location.reload();
        })


      }).catch(() => {

      });



    },
    //--------确定添加货架-------------
    confirm_goods () {
      let item = this.temporary_item
      let index = this.temporary_index

      let grid = []
      for (let index = 1; index <= this.formData.grid; index++) {
        grid.push({
          lable: index + '格',
          value: index,
        })
      }
      //生成货架层
      let tier = []
      for (let index = 1; index <= this.formData.tier; index++) {
        tier.unshift({
          lable: index + '层',
          value: index,
          children: grid
        })
      }

      console.log(item == undefined);

      if (item == undefined) {
        console.log(111);

        let cw_data = {
          lable: 1 + '号货架',
          value: 1,
          children: tier
        }
        this.$set(this.dataJson[index], 'children', [])
        this.dataJson[index].children.push(cw_data)
        this.freight_space_data(this.dataJson)
        this.$router.go(0)
        location.reload();
        return
      }


      let number = parseInt(item[item.length - 1].value) + 1
      let cw_data = {
        lable: number + '号货架',
        value: number,
        children: tier
      }
      // let requestData = this.dataJson
      console.log(cw_data);
      item.push(cw_data)
      // requestData[index].children.push(item.push(cw_data))
      this.freight_space_data(this.dataJson)
      this.$router.go(0)
      location.reload();
      this.add_show = false
    },
    //--------添加货架-------------
    add_goods_shelf (item, index) {
      this.temporary_item = item
      this.temporary_index = index
      this.add_show = true
    },
    //--------确定修改区域简介-------------
    confirm_info () {
      this.dataJson[this.active_index].info = this.briefData.info
      this.freight_space_data(this.dataJson)
      this.area_info = false
    },
    // -------------检测简介数据------
    submitForm_2 (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirm_info()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //----------修改区域简介显示--------
    alter_area_info_show (index) {
      this.briefData.info = this.dataJson[index].info
      this.area_info = true
      this.active_index = index
    },
    //----------判断是否具有相同命名--------
    repetition_name (lable) {
      if (!this.dataJson[0]) {
        return true
      }

      for (const key in this.dataJson) {
        if (this.dataJson[key].lable === lable) {
          return false
        } else {
          return true
        }

      }
    },
    //----------删除区域--------
    remove_area (index) {
      this.$confirm(`确定删除吗?该操作不可逆转!!!`, '删除区域', {
        confirmButtonText: '删 除',
        cancelButtonText: '取 消',
        type: 'warning',
      }).then(() => {

        this.dataJson.splice(index, 1);
        this.freight_space_data(this.dataJson)
      }).catch(() => {

      });
    },
    //----------确定命名--------
    confirm_name (index) {
      if (this.repetition_name(this.dataJson[index].lable)) {
        this.dataJson[index].value = this.dataJson[index].lable
        this.freight_space_data(this.dataJson)
      } else {
        this.dataJson[index].lable = this.temporary
        this.$message.error('此区域名已经存在')
      }
      this.disabledBtn = ''
    },
    //----------重命名区域--------
    rename (index) {
      this.temporary = this.dataJson[index].lable
      this.disabledBtn = index
    },
    //----------标签被选中--------
    active_label (e) {
      this.activeLabel = e.index
    },
    //----------生成数据--------
    create_data () {
      //生成格号
      let grid = []
      for (let index = 1; index <= this.formData.grid; index++) {
        grid.push({
          lable: index + '格',
          value: index,
        })
      }
      //生成货架层
      let tier = []
      for (let index = 1; index <= this.formData.tier; index++) {
        tier.unshift({
          lable: index + '层',
          value: index,
          children: grid
        })
      }

      //生成货架号
      let number = []
      for (let index = 1; index <= this.formData.number; index++) {
        number.push({
          lable: index + '号货架',
          value: index,
          children: tier

        })
      }

      let requestData = this.dataJson
      requestData.push({
        lable: this.formData.area,
        value: this.formData.area,
        info: this.formData.info,
        children: number
      })

      this.freight_space_data(requestData)


    },
    //--------检测数据是否正确-----
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.repetition_name(this.formData.area)) {
            this.create_data()
          } else {
            this.$message.error('此区域名已经存在')
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //-----------显示创建仓位--
    show_new_freight_space () {
      this.newShow = true

    },
    // ----------仓位数据-------
    async freight_space_data (requestData, funct) {
      this.fullscreenLoading = true;
      let res = ''
      if (requestData) {
        res = await apiFreightSpace({
          ckid: this.$route.query.id,
          gsinfo: requestData
        })
      } else {
        res = await apiFreightSpace({
          ckid: this.$route.query.id,
        })
      }

      common.returnData(this, res.errno, res.message, () => {
        if (requestData) {
          this.newShow = false
          this.dataJson = requestData
        } else {
          this.dataJson = res.gsinfo.slice(0, res.gsinfo.length)
        }

      }, () => {

      })
      funct ? funct() : ''
      this.fullscreenLoading = false;
    }
  },
  created () {
    this.freight_space_data()
  },
  beforeDestroy () {
    this.dataJson = []
  }
}
</script>

<style lang='scss'>
.freightSpace {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  .print_main {
    position: absolute;
    z-index: 99999;
    width: 100%;
    height: 90%;
    overflow-y: auto;
    background-color: rgba(56, 56, 56, 0.767);
    .print_main_view {
      width: 90%;
      height: 100%;
      .printBotton {
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        // background-color: pink;
        .is_true {
          background-color: #13ce66;
        }
        .is_false {
          background-color: #f56c6c;
        }
        .printBotton_btn {
          width: 200px;
          height: 100%;
          font-size: 16px;
        }
      }
      .print_main_ul {
        // display: flex;
        .print_main_li {
          display: flex;
          flex-wrap: wrap;
        }
        .printTier {
          margin-top: 10px;
        }
        .printGrid {
          display: flex;
        }
      }
    }
  }
  .prin_dialog {
    min-width: 1000px;
  }
  .printView {
    min-height: 700px;
    // min-width: 700px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .select_area {
      .grid_ul {
        display: flex;
        flex-direction: column;
        height: 100px;
      }
      ul {
        display: flex;
        .grid_li {
          width: 100%;
          justify-content: flex-start;
          flex-direction: row;
          margin-bottom: 10px;
          .el-radio__label {
            font-size: 16px;
            font-weight: normal;
            display: flex;
            padding: 0;
            height: 30px;
            margin-left: 5px;
            align-items: center;
          }
          .el-radio__inner {
          }
          .el-radio {
            margin: 0;
            margin-right: 10px;
            width: 100px;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            padding-top: 0;
          }
        }
        li {
          font-size: 18px;
          font-weight: 700;
          width: 100px;
          height: 100px;
          margin-right: 10px;
          // background-color: pink;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .el-radio {
            display: flex;
            align-items: center;
            flex-direction: column-reverse;
          }
          .el-radio__label {
            font-size: 18px;
            font-weight: 700;
            padding: 0;
            padding-bottom: 10px;
          }
        }
      }
    }
    .el-tabs {
      width: 100%;
      height: 700px;
      // background-color: pink;
      .printView_main {
        // background-color: pink;
        width: 100%;
        height: 90%;
        box-sizing: border-box;
        padding: 10px;
        .print_select_btn {
          width: 70%;
        }
      }

      .el-tabs__content,
      .el-tab-pane {
        width: 100%;
        height: 100%;
      }
      .el-tabs__nav {
        // border: 0;
      }
      .el-tabs__item {
        transition: all 0.3s;
        // border: 1px solid #cccccc;
        background-color: #ffffff;
        border-bottom: 1px solid #eeeeee;
      }
      .is-active {
        background-color: #409eff;
        color: #fff;
        // border: 1px solid #409eff;
        // background: linear-gradient(#0080ff, #ffffff);
      }
    }
  }
  .el-message-box {
    z-index: 999999;
  }
  .set_dialog {
    .pageRange {
      // background-color: pink;
      // height: 00px;
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      // justify-content: ;

      .pageRange_item {
        display: flex;
        width: 60px;
        flex-direction: column;
        margin-right: 30px;
        margin-bottom: 20px;
        // justify-content: center;
        // align-items: center;
        .active_input {
          border: 1px solid #cccccc;
          input {
            color: #409eff !important;
          }
        }
        .el-dropdown-link:hover {
          color: #409eff;
        }
        .el-dropdown-link {
          display: flex;
          justify-content: center;
          margin-top: 10px;
        }
      }
    }
    .el-input.is-disabled .el-input__inner {
      background-color: #fff !important;
      color: #333;
    }
    .el-input {
      margin-right: 10px;
      width: 60px;
      border-bottom: 1px solid #cccccc;
      input {
        border: 0;
        padding: 0;
        text-align: center;
        font-weight: 700;
        font-size: 16px;
      }
    }
  }
  .new_dialog {
    .demo-ruleForm {
      margin-left: 20px;
      display: flex;
      flex-wrap: wrap;
      .el-form-item {
        width: 50%;
      }
      .el-form-item__label {
        width: 130px;
      }
      .el-form-item__error {
        margin-left: 130px;
      }
      .el-input-number,
      .el-input {
        width: 100px;
      }
    }
  }
  .freightSpace_top {
    width: 100%;
    height: 200px;
    background-color: #fff;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .freightSpace_btn {
      width: 400px;
      height: 80%;
      display: flex;
      align-items: flex-end;
    }
    .el-button {
      width: 130px;
      height: 50px;
    }
  }
  .el-flex {
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 50px;
  }
  .freightSpace_main {
    width: 100%;
    height: 850px;
    margin-top: 5%;
    background-color: #fff;
    position: relative;

    .el-tabs__nav-wrap {
      width: 93%;
    }
    .abs_set {
      position: absolute;
      z-index: 200;
      width: 150px;
      height: 30px;
      // background-color: #66b1ff;
      right: 10px;
      top: -50px;
    }
    .all_edit {
      color: #ccc;
      transition: all 0.3s;
    }
    .all_edit:hover {
      color: #409eff;
    }
    .el-tabs__new-tab {
      margin-right: 20px;
      background-color: #67c23a;
      color: #fff;
      border: 0;
      width: 30px;
      height: 30px;
      line-height: 30px;
      font-size: 20px;
    }
    .data_null {
      color: #9da6b3;
      width: 300px;
      height: 400px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .data_null_text {
        font-size: 16px;
        display: flex;
      }
      .data_null_image {
        width: 300px;
        height: 300px;
        background: url("/assets/images/data_null.png") no-repeat;
      }
    }

    .dataJson_null {
      width: 300px;
      height: 400px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #9da6b3;
      .dataJson_null_text {
        font-size: 16px;
        display: flex;
      }
      .dataJson_null_img {
        width: 300px;
        height: 300px;
        background: url("/assets/images/order_null.png") no-repeat;
      }
    }
    .brief {
      width: 100%;
    }
    .freightSpace_main_area {
      width: 98%;
      height: 100%;
      box-sizing: border-box;
      margin: 10px;
      .add_grid {
        background-color: #67c23a;
        border: 0;
        color: #fff;
      }
      .odd_btn {
        background-color: #faf9f3;
      }
      .goods_shelf {
        width: 100%;
        .grid_data_class:hover {
          .delete_grid {
            display: flex;
          }
        }
        .goods_shelf_item {
          margin-top: 20px;
          height: 50px;
          overflow-y: hidden;
          overflow-x: auto;
          white-space: nowrap;
          .grid_data_class {
            position: relative;
          }
          .delete_grid {
            position: absolute;
            top: 0;
            color: #333;
            background-color: rgba(255, 192, 203, 0);
            right: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            font-size: 8px;
            transition: all 0.3s;
            display: none;
          }
          .delete_grid:hover {
            color: #f56c6c;
            background-color: #f5f7fa;
          }
        }
      }
      .el-tabs__content {
        height: 700px;
        // background-color: pink;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .el-tabs {
      height: 100%;
      .el-tab-pane {
        padding: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
      }
      .el-tabs__item {
        min-width: 100px;
        min-height: 50px;
        line-height: 50px;
        text-align: center;
      }
    }
  }
}
.print_area_ul {
  width: 100%;
  height: 500px;
  overflow: auto;
  // background-color: pink;
  display: flex;
  margin-top: 100px;
  justify-content: center;
}
.printArea {
  width: 75mm;
  height: 56mm;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  .printArea_top {
    font-size: 30mm;
    width: 50mm;
    display: flex;
    justify-content: center;
    border-bottom: 1px dashed #000;
  }
  .printArea_info {
    font-size: 14px;
    margin-top: 10px;
  }
}

.print_main_ul {
  width: 90%;
  overflow-y: auto;
  // height: 100vh;
  // margin: 0 auto;
  .print_code_left {
    width: 50%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    font-family: "Play";
    font-size: 14px;
  }
  .print_main_code {
    display: flex;
    justify-content: space-between;
  }
  .print_code_right {
    display: flex;
    justify-content: center;
    width: 50%;
    border-left: 1px solid #000;
  }
  .print_main_li_area {
    display: flex;
    justify-content: center;
    width: 100%;
    font-size: 10mm;
    border-bottom: 1px solid #000;
    padding-bottom: 2mm;
  }
  .barcode {
    border-top: 1px solid #000;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .print_main_li {
    width: 100%;
    // display: flex;
    margin-top: 10px;
  }
  .printTier {
    page-break-after: always;
    margin-right: 10px;
    width: 75mm;
    height: 56mm;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: #fff;
  }
}
</style>